import React, { useEffect, useState } from 'react'
import spendingAlertSuccess from "../../../../../assets/images/spending-alert-success.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { withOidcSecure } from '@axa-fr/react-oidc';
import { useDispatch, useSelector } from 'react-redux'
import logFirebaseEvents from '../../../../LogFirebaseEvents';
import { appTheme } from '../../../../../helpers/utils/Utils';
import SavingGoalIcon from '../../../../../assets/kudzu-plus-images/savingGoalIcon.png'
import { addLineBreaks } from '../../../../../utils';



const EditSuccessModal = ({ModalClose}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
    const selectedFrequencyValueDATA = useSelector((state) => state.selectedFrequencyValue);
    const { Code, DisplayText } = selectedFrequencyValueDATA;
    const appThemeData = appTheme(kudzuPlusTrue);
    const [succesMsg, setSuccesMsg] = useState('')

    const handleOk = () => { 
        ModalClose(false)
        navigate('/Toolkit/SavingGoals/ManageSavingGoal');
        dispatch({ type: "RESET_ALLOCATE_FUND" })
 
    }
 
 
    useEffect(() => {
        switch (DisplayText) {
            case "One Time":  
            setSuccesMsg(addLineBreaks(t('One_Time')))
                break;
            case "Weekly": 
            setSuccesMsg(addLineBreaks(t('Weekly')))
                break;
            case "Monthly": 
            setSuccesMsg(addLineBreaks(t('Monthly')))
                break;
            case "Daily": 
            setSuccesMsg(addLineBreaks(t('daily_success_msg')))
                break;
        }
    }, [DisplayText])


 

    return (
        <div className='flex flex-col w-full'>
        <p className='font-hanken-grotesk lg:text-[18px] md:text-[18px] sm:text-[14px] text-[16px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] 
         md:leading-[28px] text-[var(--heading-in-modal-is-clr)] '>{succesMsg}</p>

        <img src={SavingGoalIcon} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10 mx-auto' />
        <div className='flex flex-col justify-center items-center w-full'>

            <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                

                <button autoFocus class="focus:outline-none   font-hanken-grotesk lg:text-[18px] md:text-[17px] 
sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full" onClick={ handleOk} onKeyDown={(e) => { if (e.key === "Enter") handleOk() }}>{t("Ok")}</button>
            
                   
            </div>
        </div>

    </div>
    )
}

export default withOidcSecure(EditSuccessModal)